import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  // FileUploader,  
  // TextArea,
  Modal
} from "carbon-components-react";
import NumberFormat from "react-number-format";
import { Breadcrumb, ExpandableCard } from "../../../../components";
import { getByDmService, insertDmService, pathDmService, deleteDmService } from "../../../../services/Api";
// import InfoIcon from "../../../../components/Icons/InfoIcon";
// import appConfig from "../../../../config/app-config";
import ModalDm from "../../../../components/Modal/ModalDm";
// import { forceDownload } from "../../../../lib/validations";

// const { IMAGE_PATH, IMAGE_PATHV2 } = appConfig;

const RightComponent = () => (
  <button className="btn-secondary-outlined bx--btn" type="button">
    Editar
  </button>
);

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFinishedStep1: false,
      dadosLoja: false,
      dadosMarca: false,
      dadosObservacao: false,
      cnpj: "",
      nomeFantasia: "",
      razaoSocial: "",
      logo: "",
      filelogo: null,
      filemanualMarca: null,
      filemascote: null,
      mascote: "",
      slogan: "",
      observacao: "",
      openMdInfo: false,
      infoModal: "",
      headerModal: "",
      filesUploads: [],
      expandedOn: false,
      expandedTwo: false,
      expandedThree: false,
      logoName: null,
      manualMarcaName: null,
      mascoteName: null,
      showDescriptionLoja: true,
      showDescriptionBrand: true,
      disabledBtnSave: false,
      successModel: false,
      nrPedido: 0,
      statusPreCadastro: 3
    };
  }

  componentDidMount = async () => {
    await this.getItems();
    
  };

  LeftComponentStore = () => {
    const { cnpj, razaoSocial, nomeFantasia } = this.state;
    const active = !!((cnpj && razaoSocial && nomeFantasia));

    return (
      <div
        className={`step-card-icon ${active ? "step-card-icon--actived" : ""}`}
      >
        <i className="material-icons">
          {!active ? "check_circle_outline" : "check_circle"}
        </i>
      </div>
    );
  };

  LeftComponentIdentity = () => {
    const {
      logoName,      
    } = this.state;
    const active = !!(
      logoName
    );
    return (
      <div
        className={`step-card-icon ${active ? "step-card-icon--actived" : ""}`}
      >
        <i className="material-icons">
          {!active ? "check_circle_outline" : "check_circle"}
        </i>
      </div>
    );
  };

  LeftComponentObservation = () => {
    const { observacao } = this.state;
    const active = !!observacao;
    return (
      <div
        className={`step-card-icon ${active ? "step-card-icon--actived" : ""}`}
      >
        <i className="material-icons">
          {!active ? "check_circle_outline" : "check_circle"}
        </i>
      </div>
    );
  };

  getItems = async () => {
    const { match } = this.props;
    try {
      if (match.params.id && match.params.id > 0) {
        const result = await getByDmService(
          "/Pedido/GetPrecadastro",
          match.params.id
        );
       
        const data = result.itensPrecadastro.pop();
        console.log(result)
        const statusPreCadastro = result.status || {}
        this.setState({ 
          ...data,
          nrPedido: result.numero,
          logoName: data.logo,
          statusPreCadastro
        });
        await this.loadUploads(result.referencias)
      }
    } catch (e) {
      if (e.message) toast.error(e.message);
      else toast.error("Ocorreu um erro ao carregar os dados");
    }
  };

  uploadFileLogo = async id => {
    const { filelogo, filesUploads } = this.state;
    if (filelogo) {
      try {
        const dataA = await new FormData();
        await dataA.append("file", filelogo);
        const uploadLogo = await insertDmService(`/Pedido/UploadPrecadastro?tipo=1&id=${id}`, dataA);
        await this.setState(prevState => ({
          filesUploads: [...prevState.filesUploads, uploadLogo],
          isUplogo: true
        }));
        await Promise.all(filesUploads);
      } catch (error) {
        console.log("error upload logo", error)
      }
    }
  };

  uploadFileMarca = async id => {
    const { filemanualMarca, filesUploads } = this.state;
    if (filemanualMarca) {
      try {
        const dataA = await new FormData();
        await dataA.append("file", filemanualMarca);
        const uploadMarca = await insertDmService(`/Pedido/UploadPrecadastro?tipo=2&id=${id}`, dataA);
        await this.setState(prevState => ({
          filesUploads: [...prevState.filesUploads, uploadMarca],
          isUpManual: true
        }));
  
        await Promise.all(filesUploads);
      } catch (error) {
        console.log("error upload marca", error)
      }
    }
    
  };

  uploadFileMascote = async id => {
    const { filemascote, filesUploads } = this.state;
    if (filemascote) {
      try {
        const dataA = await new FormData();
        await dataA.append("file", filemascote);
        const uploadMascote = await insertDmService(`/Pedido/UploadPrecadastro?tipo=3&id=${id}`, dataA);
        await this.setState(prevState => ({
          filesUploads: [...prevState.filesUploads, uploadMascote],
          isUpMascote: true
        }));
        await Promise.all(filesUploads);
      } catch (error) {
        console.log("error upload mascote", error);
      }
    }
    
  };

  addTag = tag => {
    this.setState(prevState => ({
      observacao: `${prevState.observacao}${tag}`
    }));
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  fileChange = (e, name) => {
    const { files } = document.getElementsByName(name)[0];

    if (files && files.length > 0) {
      this.setState({
        [`${name}Name`]: files[0].name,
        [`file${name}`]: files[0]
      });
    }
  };

  setFinished = finish => {
    const {cnpj, razaoSocial, nomeFantasia} = this.state
    if(finish === "fini1"){
      const isFinishedStep1 = cnpj !== "" && razaoSocial !== "" && nomeFantasia !== "";
      if(isFinishedStep1){
        this.setState(prevState => ({
          isFinishedStep1,
          dadosLoja: true,
          expandedOn: !prevState.expandedOn,
        }))
      }
    }
  };

  runFinished = () => {
    const { dadosLoja} = this.state;
    this.setState({
      isFinishedStep1: dadosLoja,
    });
  };

  finishOrder = () => {
    const {history} = this.props;
    history.push("/pedidos/agencia");
  };

  onsubmit = async e => {
    e.preventDefault();
    const { match } = this.props;

      try {
        await this.save();
        const idRequest = await localStorage.getItem("idRequest");
        await this.uploadFileLogo(idRequest);        
        await this.uploadFileMarca(idRequest);
        await this.uploadFileMascote(idRequest);
        await this.runFinished();
       
        if (match.params.id && match.params.id > 0) {
          const {history} = this.props
          // await this.save() 
          await toast.success("Pedido editato com sucesso.");
          history.goBack();
          // history.push("/admin/pre-cadastros/pendentes");
        }else{
          await this.setState({
            successModel: true
          });
        }

      } catch (ex) {
        console.log(ex);
        toast.error("Ocorreu uma falha ao processar os dados");
      }
  };

  removeUpload = async(index, id) => {
    try {
      if(id)
        await deleteDmService('/Pedido/DeleteArquivoReferencia', [id]);
      this.setState(prevState => {
        const newList = [...prevState.uploads];
        newList.splice(index, 1);
        return { uploads: newList };
      });
    } catch (error) {
      toast.error("Ocorreu uma falha ao excluir o arquivo");
    }
  }
  
  fileChangeReferencia = async (name) => {
    const { files } = document.getElementsByName(name)[0];
    this.setState(prevState => {
      const uploads = prevState.uploads || [];
      for (let i = 0; i < files.length; i++) uploads.push(files[i]);
      return { ...prevState, uploads };
    });
  }

  loadUploads = async(referencias) => {

    const uploads = referencias ? referencias.map(item => ({
      id: item.id,
      name: item.imagem
    })) : []

    this.setState({ uploads })
  }

  save = async () => {
    const {
       cnpj,
      nomeFantasia,
      razaoSocial
    } = this.state;

    const permissionSave = cnpj !== "" && cnpj !== "" && razaoSocial !== "";
    const { match } = this.props;
    const formData = {
    
      cnpj,
      nomeFantasia,
      razaoSocial
    };

    if (match.params.id && match.params.id > 0) {
      formData.Pedido = match.params.id;      
    }

    if(permissionSave){

      try {
        let data = []
        if(match.params.id){
          data = await pathDmService(
            `/Pedido/EditaPrecadastro/${match.params.id}`,
            formData
          );
          await localStorage.setItem("idRequest", match.params.id)
        }else{
           data = await insertDmService(
            "/Pedido/GeraPedidoPrecadastro",
            formData
          );
          await localStorage.setItem("idRequest", data.id)
          await this.setState({nrPedido: data.codigo});           
        }
       
        await this.setState({
          disabledBtnSave: true
        });
        
       
        
      } catch (error) {      
        toast.error(error.message);
      }
    }else{
      const requiredsMissing = [];
     
      if(cnpj === ""){
        requiredsMissing.push("CNPJ");
      }

      if(razaoSocial === ""){
        requiredsMissing.push("Razão Social");
      }
      
      if(nomeFantasia === ""){
        requiredsMissing.push("CNPJ e Razão Social");
      }

      let messageWarn = "Você ainda precisa preencher os seguintes campos: ";
      let idx = 1;
      for (const item of requiredsMissing) {
        if(requiredsMissing.length === idx){
          messageWarn += ` ${item}`
        }else{
          messageWarn += ` ${item}, `
        }

        idx++
      }

      toast.warn(messageWarn)
    }

    return null
  };

  openModalInfo = (header, info) => {
    this.setState({
      openMdInfo: true,
      infoModal: info,
      headerModal: header
    });
  };

  closeModalInfo = () => {
    this.setState({
      openMdInfo: false
    });
  };

  
  uploadFileReferences = async idItem => {
    const { uploads } = this.state;
    await Promise.all(
      uploads.map(async file => {
        try {
          const data = new FormData();
          data.append('file', file);
          await insertDmService(`/Pedido/UploadArquivoReferencia/?IdItemPedido=${idItem}`, data);         
        } catch (err) {          
          toast.error(`Falha ao fazer upload: ${err.message}`);
        }
      }),
    );
  };

  render() {
    const {
      isFinishedStep1,
      cnpj,
      nomeFantasia,
      razaoSocial,
      id,
      openMdInfo,
      infoModal,
      headerModal,
      dadosLoja,
      expandedOn,
      disabledBtnSave,
      successModel,
      nrPedido,
      statusPreCadastro,
    } = this.state;
    const { location, match } = this.props;
    const {path} = match;
    const user = JSON.parse(localStorage.getItem('user'));

    const canEdit =  user.nivel.id === 10 || statusPreCadastro.id !== 6;
    console.log("canEdit",canEdit, user.nivel, statusPreCadastro.id)
    const disabledRequireds = disabledBtnSave || cnpj === ""  || razaoSocial === "" || nomeFantasia === "";
    let urlBack = "/pedidos/agencia";
    if(path === "/admin/pre-cadastro/:id"){
      urlBack = statusPreCadastro === 3 ? "/admin/pre-cadastros/pendentes" : "/admin/pre-cadastros/aprovados"
    }
    return (
      <div className="pre-register-page">
        <Breadcrumb
          title=" Pré-Cadastro "
          renderLeft={(() => (
            <div className="breadcrumb-left-actions">
              {location.pathname !== "/agencia/pre-cadastro/" && (
                <NavLink to={urlBack}>
                  <svg width="16" height="14" viewBox="0 0 16 14">
                    <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
                  </svg>
                </NavLink>
              )}
            </div>
          ))()}
          description=""
        />

        <section className="content-wrapper content-wrapper--large">
          <form id="form" onSubmit={this.onsubmit}>
            <ExpandableCard
              className="center-box"
              title="Dados da Unidade"
              disabled={!canEdit}
              onToggle={expanded =>
                this.setState({
                  dadosLoja: expanded,
                  showDescriptionLoja: expanded
                })
              }
              description={
                (() => (
                  <div>
                    <strong>CNPJ:</strong>
                    {cnpj}
                    <br />
                    <strong>Razão social: </strong>
                    {razaoSocial}
                    <br />
                    <strong>Nome Fantasia: </strong>
                    {nomeFantasia}
                    <br />
                  </div>
                ))()
              }
              expanded={isFinishedStep1}
              openCard={expandedOn}
              leftComponent={this.LeftComponentStore}
              rightComponent={() => (
                <div style={{ flexDirection: "column", display: "flex" }}>
                  {RightComponent()}
                </div>
              )}
            >
              <div className="mg-left-20">
                {!dadosLoja && (
                  <div>
                    <div className="bx--row">
                      <div className="v-md-margin">
                        <label className="bx--label">
                          CNPJ
                          <span className="required-asterisk"> *</span>
                        </label>
                        <NumberFormat
                          className="bx--text-input"
                          format="##.###.###/####-##"
                          required
                          placeholder="cnpj"
                          name="cnpj"
                          value={cnpj}
                          onChange={this.onChangeText}
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="v-md-margin">
                        <label className="bx--label">
                          Razão Social
                          <span className="required-asterisk"> *</span>
                        </label>
                        <input
                          type="razaoSocial"
                          className="bx--text-input"
                          required
                          placeholder="Razão Social"
                          name="razaoSocial"
                          value={razaoSocial}
                          onChange={this.onChangeText}
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="v-md-margin">
                        <label className="bx--label">
                          Nome fantasia
                          <span className="required-asterisk"> *</span>
                        </label>
                        <input
                          type="nomeFantasia"
                          className="bx--text-input"
                          required
                          placeholder="Nome fantasia"
                          name="nomeFantasia"
                          value={nomeFantasia}
                          onChange={this.onChangeText}
                        />
                      </div>
                    </div>
                    <div className="bx--row">
                      <div className="v-md-margin">
                        <button
                          onClick={() => this.setFinished("fini1")}
                          className="btn-secondary-color bx--btn mg-top-20"
                          type="button"
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </ExpandableCard>

            

           
            {canEdit && (
              <Button style={{ width: "100%" }} type="submit" disabled={disabledRequireds}>
                {id ? "Atualizar" : "Finalizar pedido"}
              </Button>
            )}

          </form>
        </section>
        <div className="modal-info">
          <ModalDm
            heading={headerModal}
            hiddenModal={this.closeModalInfo}
            openMd={openMdInfo}
          >
            <div className="bx--modal-content">
              <p>{infoModal}</p>
            </div>
            <div className="bx--modal-footer">
              <button
                onClick={this.closeModalInfo}
                className="bx--btn btn-secondary-color"
                type="button"
              >
                Fechar
              </button>
            </div>
          </ModalDm>

          <Modal
            className="bx--modal-secondary-hide"
            open={successModel}
            onRequestSubmit={() => this.finishOrder()}
            modalHeading="Pedido feito com sucesso."
            primaryButtonText="Meus Pedidos"
            secondaryButtonText={null}
          >
            <div className="warning-modal-txt">
              <h3>
                {`Seu pedido ${nrPedido} está sob avaliação.`}
              </h3>              
              <p className="font-size-13 v-md-margin">
                {`A qualquer momento você poderá acompanhá-lo clicando em `}
                <a className="notifications pointer" href="/pedidos/agencia">
                  <i className="assignment" />
                </a>
              </p>
            </div>
          </Modal>          
        </div>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/screens/admin/PreRegistration/Detail/Main.js